import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import React, { useState ,useEffect} from "react";
import { Button,Input,message,Table  } from "antd";
import PopupModal from "../../../../Components/PopupModal";
import { getDistrictCircles,editTableValues } from "../../../../actionCreators/Zones";
import InputLabel from "../../../../Components/FloatingSelectLabel/FloatingSelectLabel";

const CirclesTable=({
  district,
  districtCircles,
  tableValues,
  editTableValues,
  getDistrictCircles
  })=>{
    const [data,setData]=useState(null)
    const [loading,setLoading]=useState(null)
    const [pagination,setPagination]=useState(null)
    const [details,setDetails]=useState(null)
    const [showModal,setShowModal]=useState(false)
    const [circle,setCircle]=useState(null)
    const [code,setCode]=useState(null)
    const [showWarning,setShowWaring]=useState(false)
    const [btnloading,setBtnLoading]=useState(false)
    const [page,setpage]=useState(1)
    const [limit,setLimit]=useState(5)
    const [errorMessage,setErrorMessage]=useState(null)
    const [nameError,setNameError]=useState('success')
    const [codeError,setCodeError]=useState('success')
    useEffect(()=>{
      getDistrictCircles({district_id:district,page:page,limit:limit})
    },[])
    useEffect(()=>{
      if(districtCircles.data)
      {
        setData(districtCircles.data.rows)
        setPagination(districtCircles.data.pagination)
        setLoading(districtCircles?.loading)
      }
    },[districtCircles])
    useEffect(()=>{
      if(tableValues.data && !tableValues.error)
      { 
        setBtnLoading(tableValues.loading)
        setShowModal(false);
        setShowWaring(false)
        setDetails(false);
        setCircle(null);
        setCode(null);
        getDistrictCircles({district_id:district,page:page,limit:limit})
      }
      if(tableValues.error)
      {
        setBtnLoading(tableValues.loading)
        setErrorMessage(tableValues?.error)
        setShowWaring(true)
      }
    },[tableValues])
    const onTableRowClick=(value)=>{
      setDetails(value)
      setCircle(value?.name)
      setCode(value?.code)
      setShowModal(true)
    }
    const handleUpdate=()=>{
      if(circle && code)
      {
        editTableValues({circle_id:details?.id,name:circle,code:code,type:'circle',force:showWarning})
        setBtnLoading(true)
      }
      else
      {
        if(!circle)
        {
          setNameError('error')
        }
        if(!code)
        {
          setCodeError('error')
        }
      }
      
    }
    const handleTableChange = (tableCahngeData, filters, sorter) => {
      const{current,pageSize}=tableCahngeData
      setpage(current)
      setLimit(pageSize)
      getDistrictCircles({district_id:district,page:current,limit:pageSize})
    }
    const tableColumns=[
        {
            title:'Name',
            dataIndex:"name",
            align:'center',
            width:'33%',
            render: (name) => (name ? name : "---"),
        },
        {
            title:'Code',
            dataIndex:"code",
            align:'center',
            width:'33%',
            render: (code) => (code ? code : "---"),
        },
        {
            title:"Actions",
            width:'33%',
            align:'center',
            render: (data,row) => (
                <span style={{color:'blue', cursor:'pointer'}} onClick={()=>{
                    onTableRowClick(row)
                }}>Edit</span>
            ),
        }
    ]

    return(
        <div className="logs-body" style={{ marginBottom: "20px" }}>
          <div className="lookupdataTableheader" >
              Circles 
          </div>
          <div>
            <Table
              rowClassName="table-row-cursor-pointer"
              columns={tableColumns}
              dataSource={data}
              rowKey={(record) => record.id}
              loading={loading}
              bordered={true}
              onRow={(record) => {
                return {
                  onClick: (event) => {
                    if (event.target.tagName === "TD") {
                      onTableRowClick(record);
                    }
                  },
                };
              }}
              pagination={{
                defaultPageSize: 5,
                current: pagination?.currentPage + 1,
                total: pagination?.count,
                showSizeChanger: true,
                pageSizeOptions: ["5", "10", "15"],
                position: ["bottomRight"],
              }}
              onChange={handleTableChange}
            />
          </div>
          <PopupModal
            title={"Edit Circle Details"}
            centered
            visible={showModal}
            onCancel={() => 
              {
                setShowModal(false)
                setDetails(null)
                setNameError('success')
                setCodeError('success')
              }
            }
            footer={[
              <Button
                key="cancel"
                type="link"
                onClick={() => {
                    setShowModal(false);
                    setDetails(null)
                    setNameError('success')
                    setCodeError('success')
                }}
                style={{color:'red'}}
              >
                Cancel
              </Button>,
              <Button
                key="submit"
                type="link"
                disabled={code&&circle?false:true}
                onClick={handleUpdate}
                loading={btnloading}
                >
              Save
            </Button>
            ]}
          >
            <InputLabel
              value={circle}
              labelText="Name"
              active={circle?true:false}
            >
                <Input className="input-lookup-data" status={nameError} value={circle} onChange={(e)=>{setCircle(e.target.value)}}/>
            </InputLabel>
            <br/>
            <InputLabel
              value={code}
              labelText="Code"
              active={code?true:false}
            >
                <Input className="input-lookup-data" status={codeError} value={code} onChange={(e)=>{setCode(e.target.value)}}/>
            </InputLabel>
          </PopupModal>
          <PopupModal
            title={"Warning"}
            centered
            visible={showWarning}
            onCancel={() => {setShowWaring(false)}}
            footer={[
              <Button
                key="cancel"
                type="default"
                style={{color:'red'}}
                onClick={() => {
                  setShowWaring(false);
                }}
              >
                Cancel
              </Button>,
              <Button
                key="submit"
                type="link"
                onClick={handleUpdate}
                loading={btnloading}
                >
              Continue
            </Button>
            ]}
          >
            {errorMessage} Are you want to continue?
          </PopupModal>
        </div>
    )
}
const mapStateToProps = ({
  zones:{tableValues,districtCircles}
}) => ({
  tableValues,
  districtCircles
});

const mapDispatchToProps = (dispatch) => ({
  editTableValues:bindActionCreators(editTableValues, dispatch),
  getDistrictCircles:bindActionCreators(getDistrictCircles, dispatch),

});

export default connect(mapStateToProps, mapDispatchToProps)(CirclesTable);